import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../store/reportStore';
import Paging from '../common/pagingComponent';
import ExcelExportButton from '../common/excelExportButton';
import OldStyleTableWithHistory from '../common/oldStyleTableWithHistory';

class Alerts extends React.Component {
    state = { page: 1 }

    get pageSize() {
        const limits = this.props.getSectionLimits(this.props.reportType, this.props.sectionId);
        return this.props.isLimited ? limits.pageSize.limited : limits.pageSize.unlimited;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? null : this.renderContent(this.props.data, this.props.isLimited));
    }

    renderContent = (data, isLimited) => {
        return (
            <div>
                <OldStyleTableWithHistory
                    offsetLeft={false} stripped
                    head={() => this.renderHead()} tableColumns={6}
                    actualData={data.alerts} actualRow={(r) => this.renderRow(r)}
                    resolveExpanded={this.props.resolveExpanded}
                />
                {isLimited && data.alerts.length < data.totalCount && <div style={{ marginLeft: "0.7em", marginBottom: "1em" }}>
                    <a href={this.props.getUnlimitedSectionLink(this.props.reportType, this.props.id, this.props.sectionId)} target="_blank" className="link-functional">
                        <Translate id="Report.Common.ShowAll" />&nbsp;({data.totalCount})
                    </a>
                </div>}
                {!isLimited && data.totalCount > this.pageSize && <div style={{ marginTop: "2em" }}>
                    <Paging
                        justify="center"
                        selectedPage={this.state.page}
                        totalPages={Math.ceil(data.totalCount / this.pageSize)}
                        setPage={page => this.onChangePage(page)}
                    />
                </div>}
                <ExcelExportButton link="alerts" entityId={this.props.id} report={this.props.reportType} />
            </div>
        )
    }

    renderHead = () => {
        return (
            <thead>
                <tr>
                    <th><Translate id="Report.Alerts.Type" /></th>
                    <th><Translate id="Report.Alerts.Description" /></th>
                    <th style={{ width: "4.5em" }}><Translate id="Report.Alerts.Source" /></th>
                    <th><Translate id="Report.Alerts.OldData" /></th>
                    <th><Translate id="Report.Alerts.NewData" /></th>
                    <th style={{ width: "7.5em", textAlign: "right" }}><Translate id="Report.Alerts.Date" /></th>
                </tr>
            </thead>
        )
    }

    renderRow = (r) => {
        return (
            <tr key={r.id} className="colorize">
                <td>{r.type}</td>
                <td>{ReactHtmlParser(this.renderLink(r.description))}</td>
                <td>{r.source}</td>
                <td>{ReactHtmlParser(this.renderLink(r.oldValue))}</td>
                <td>{ReactHtmlParser(this.renderLink(r.newValue))}</td>
                <td style={{ textAlign: "right" }}>{r.refDateFormated || r.insertedFormated}</td>
            </tr>
        );
    }

    onChangePage = (page) => {
        this.props.fetchMoreData(
            [this.props.sectionId],
            { count: this.pageSize, offset: (page - 1) * this.pageSize, report: this.props.reportType },
            null, this.replaceData, () => this.setState({ page: page })
        );
    }

    replaceData = (_hint, _oldData, newData) => newData;

    renderLink = (str) => {
        return str.replace("<a", "<a class=\'link-external" + (localStorage.locales_url_format === 'normal' ? ' is-normal\'' : '\''));
    }
}

export default withLocalize(connect(
    null,
    dispatch => bindActionCreators(reportActions, dispatch)
)(Alerts));
